document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-nr-slider]').forEach((wrap) => {
    const track = wrap.querySelector('[data-nr-track]');
    const prev = wrap.querySelector('[data-nr-prev]');
    const next = wrap.querySelector('[data-nr-next]');

    if (!track || !prev || !next) return;

    const getStep = () => {
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.getPropertyValue('--gap')) || 0;
      const perView = parseFloat(styles.getPropertyValue('--per-view')) || 5;
      return (track.clientWidth / perView) + gap;
    };

    prev.addEventListener('click', () => track.scrollBy({ left: -getStep(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left:  getStep(), behavior: 'smooth' }));

    track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
        e.preventDefault();
        track.scrollBy({ left: e.deltaY, behavior: 'auto' });
      }
    }, { passive: false });
  });
});
